module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.playerData) ? _c('div', {
    staticClass: "lifebar"
  }, [_c('img', {
    attrs: {
      "src": _vm.playerData.img,
      "alt": _vm.playerData.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lifebar__infos"
  }, [_c('div', {
    staticClass: "lifebar__infos__detail"
  }, [_c('p', [_vm._v(_vm._s(_vm.playerData.name))]), _vm._v(" "), _c('p', [_vm._v(" - ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getMoney) + " M€")])]), _vm._v(" "), _c('div', {
    staticClass: "lifebar__bar"
  }, [_c('div', {
    class: ['lifebar__bar-progress', _vm.more ? 'lifebar__bar-progress--more' : '', _vm.less ? 'lifebar__bar-progress--less' : '']
  }, [_c('span', {
    style: ({
      width: (_vm.widthBar + "px")
    })
  })])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8aa6181c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/game/Lifebar.vue
// module id = 90
// module chunks = 0